import { AuthenticatedLayout } from "../../../layouts";
import { EHTOntarioReport } from "../../../components/Reports/EHTOntario/EHTOntarioReport";
import { FC } from "react";

export interface IEHTOntarioReportPage {}

export const EHTOntarioReportPage: FC<IEHTOntarioReportPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="EHT Ontario"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<EHTOntarioReport />}
		/>
	);
};
